module.exports = __webpack_public_path__ + "assets/img/lico.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/lico.png
// module id = 697
// module chunks = 0